import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";


const CustomSearchField = styled.input`
    width: 458px;
    background-color: var(--gray-secondary);
    border: 1px solid var(--line-secondary);
    font-size: var(--font-);
    border-radius: var(--space-xxs);

    
    &::placeholder {
      color: var(--font-secondary);
    }
    
    &:focus {
      outline: none;
      box-shadow: var(--focus);
    }
    
    &:focus-within {
      //outline: none;   
    }
    
    &:active {
      //outline: none;
    }
    height: 40px;
    text-indent: var(--space-s);
    //margin: 20px 0 20px var(--space-s1);
`;

function SearchFieldComponent(props) {

    const {placeholder, onSearchChange} = props;

    return (
        <CustomSearchField type="text" placeholder={placeholder} onChange={onSearchChange}/>
    );
}

SearchFieldComponent.propTypes = {
    placeholder: PropTypes.string,
    onSearchChange: PropTypes.func
};
SearchFieldComponent.defaultProps = {};

export default SearchFieldComponent;
